export default __webpack_public_path__ + "static/media/hht2_ep02_timeline_q01_b.982bbea1.png";